import { takeEvery, takeLatest, call, select } from 'redux-saga/effects';
import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';

// SAGAS
import {
	getReplayListSaga,
	getReplayDataSaga,
} from '@/redux/new_store_structure/sagas/evacReplay';
import {
	getNotificationsListSaga,
	delNotificationSaga,
	addEditNotificationSaga,
	getNotificationsDetailsSaga,
} from '@/redux/new_store_structure/sagas/notifications';
import {
	getSitesListSaga,
	getSitesZonesListSaga,
} from '@/redux/new_store_structure/sagas/sites';
import { getHoldersListSaga } from '@/redux/new_store_structure/sagas/holders';
import { getVisitsListSaga } from '@/redux/new_store_structure/sagas/visits';
import { getHolderZoneReportSaga } from "@/redux/new_store_structure/sagas/holderZoneReport";
import { getHolderAbsenceReportSaga } from "@/redux/new_store_structure/sagas/holderAbsenceReport";
/**
 * takeEvery - listener of action types that start sagas
 * takeLatest -  And if this action matches pattern , takeLatest starts a new saga task in the background
 *
 * @param actionTypes
 * @param saga
 */
export default function* rootSaga() {
	yield takeLatest(actionTypes.EVAC_REPLAY_LIST_GET, getReplayListSaga);
	yield takeLatest(actionTypes.EVAC_REPLAY_DATA_GET, getReplayDataSaga);
	yield takeLatest(
		actionTypes.NOTIFICATIONS_LIST_GET,
		getNotificationsListSaga,
	);
	yield takeEvery(actionTypes.NOTIFICATIONS_DELETE, delNotificationSaga);
	yield takeEvery(
		actionTypes.NOTIFICATIONS_ADD_EDIT,
		addEditNotificationSaga,
	);
	yield takeLatest(
		actionTypes.NOTIFICATIONS_DETAILS_GET,
		getNotificationsDetailsSaga,
	);
	yield takeLatest(actionTypes.SITES_LIST_GET, getSitesListSaga);
	yield takeLatest(actionTypes.SITES_ZONES_LIST_GET, getSitesZonesListSaga);
	yield takeLatest(actionTypes.HOLDERS_LIST_GET, getHoldersListSaga);
	yield takeLatest(actionTypes.VISITS_LIST_GET, getVisitsListSaga);
  yield takeLatest(actionTypes.HOLDER_ZONE_REPORT_GET, getHolderZoneReportSaga);
  yield takeLatest(actionTypes.HOLDER_ABSENCE_REPORT_GET, getHolderAbsenceReportSaga);
	// logger
	// yield takeEvery('*', function* logger(action) {
	// 	const state = yield select(store => store.sites);
	//
	// 	console.log('action', action);
	// 	console.log('state after', state);
	// });
	// Load app auth data
	// yield call(loadAuthDataSaga); //TODO
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/sagas/index.js